__turbopack_context__.v({
  "BlueGreen": "GMSY1W_BlueGreen",
  "HideDesktop": "GMSY1W_HideDesktop",
  "HideIpad": "GMSY1W_HideIpad",
  "Highlighted": "GMSY1W_Highlighted",
  "PinkBlue": "GMSY1W_PinkBlue",
  "PinkOrange": "GMSY1W_PinkOrange",
  "PinkPurple": "GMSY1W_PinkPurple",
  "Root": "GMSY1W_Root",
  "SlideShowButtons": "GMSY1W_SlideShowButtons",
  "SlideShowIndicator": "GMSY1W_SlideShowIndicator",
  "SlideShowIndicatorBase": "GMSY1W_SlideShowIndicatorBase",
  "SlideShowIndicatorContainer": "GMSY1W_SlideShowIndicatorContainer",
  "Visible": "GMSY1W_Visible",
  "White": "GMSY1W_White",
});
